'use client'

import { motion } from 'framer-motion'

import {
  CitiLogo,
  Container,
  DarpaLogo,
  EuronextLogo,
  fadeInUp,
  GoldmanSachsLogo,
  KpmgLogo,
  staggerContainer,
  TmxLogo,
  UsNavyLogo,
} from 'design-studio'
import { Join } from 'design-studio/lib'

const LOGOS = [
  { Component: CitiLogo, label: 'Citi' },
  { Component: GoldmanSachsLogo, label: 'Goldman Sachs' },
  { Component: EuronextLogo, label: 'Euronext' },
  { Component: KpmgLogo, label: 'KPMG' },
  { Component: TmxLogo, label: 'TMX' },
  { Component: DarpaLogo, label: 'DARPA' },
  { Component: UsNavyLogo, label: 'US Navy' },
]

const logoStagger = {
  initial: {},
  animate: { transition: { staggerChildren: 0.06 } },
}

const logoItem = {
  initial: { opacity: 0, y: 10 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: [0, 0, 0.2, 1] as const },
  },
}

interface TrustedByProps {
  className?: string
}

export function TrustedBy({ className }: TrustedByProps) {
  return (
    <Container className={Join('max-w-7xl', className)}>
      <motion.div
        variants={staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.25 }}
        className="flex flex-col items-center gap-6 md:flex-row md:items-center md:justify-between md:gap-3"
      >
        <motion.p
          variants={fadeInUp}
          className="text-center text-base text-slate-300 uppercase md:text-left"
        >
          Trusted by
        </motion.p>

        {/* Mobile: wrapped grid centered. Desktop: hidden — logos spread via the flat row below. */}
        <motion.div
          variants={logoStagger}
          className="flex flex-wrap items-center justify-center gap-x-6 gap-y-5 md:hidden"
        >
          {LOGOS.map(({ Component, label }) => (
            <motion.div key={label} variants={logoItem}>
              <Component
                aria-label={label}
                className="h-16 w-auto text-white"
              />
            </motion.div>
          ))}
        </motion.div>

        {/* Desktop: individual items spread across via parent justify-between */}
        {LOGOS.map(({ Component, label }) => (
          <motion.div
            key={label}
            variants={logoItem}
            className="hidden md:flex"
          >
            <Component aria-label={label} className="h-16 w-auto text-white" />
          </motion.div>
        ))}
      </motion.div>
    </Container>
  )
}
